// extracted by mini-css-extract-plugin
module.exports = {"all":"Video_all__DYMo9","container":"Video_container__3G-Mm","videoarea":"Video_videoarea__3-5mM","textarea":"Video_textarea__1nnXO","player":"Video_player__RqJq6"};